
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class PickUpItemsGrid extends Serenity.EntityGrid<PickUpItemsRow, any> {
        protected getColumnsKey() { return 'ECommerce.PickUpItems'; }
        protected getDialogType() { return PickUpItemsDialog; }
        protected getIdProperty() { return PickUpItemsRow.idProperty; }
        protected getInsertPermission() { return PickUpItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return PickUpItemsRow.localTextPrefix; }
        protected getService() { return PickUpItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
       
        }

        
    } 
} 